import { DadosDeslogarType } from "../types";

export function mapperDadosDeslogar(data: string): DadosDeslogarType {
  const dadosObj = data

    .trim()
    .split(";")
    .reduce(
      (a, c, i) => ({
        ...a,
        [["idUsuario", "idGrupo", "idRetorno", "descRetorno"][i]]: c,
      }),
      {}
    );

  return dadosObj as DadosDeslogarType;
}
